import { useNavigation } from "@react-navigation/native";
import { Button, TextField, View } from "@towersystems/roam-common-native";
import { useWatch } from "react-hook-form";
import {
  useCurrentCountContext,
  useStockCountSearchContext,
} from "../../../../../../../../../../utilities/stock-count/hooks";
import { ensuredFocusProps } from "../../../../constants";

type StandardCountContentProps = {
  stockCountId: string;
  compact?: boolean;
};

export function StandardCountContent({
  stockCountId,
  compact,
}: StandardCountContentProps) {
  const { navigate } = useNavigation<any>();

  const { stockSelection, stockAdjuster } = useCurrentCountContext();

  const {
    countInputRef,
    isSubmitDisabled,
    methods,
    handleChangeAdjustBy,
    handleOnSubmitCount,
    submitAdjustBy,
  } = stockAdjuster;

  const { scanMode } = useStockCountSearchContext();

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = methods;

  const adjustBy = useWatch({ control, name: "counted" });

  const primaryButton =
    scanMode === "quick" ? (
      <View style={{ maxWidth: 100 }} flex>
        <Button
          {...{
            fullWidth: true,
            disabled: isSubmitDisabled,
            label: "Count",
            onPress: handleSubmit((fields) =>
              submitAdjustBy({
                stockIdentifier: stockSelection?.stockIdentifier,
                adjustBy: fields.counted,
              })
            ),
            isAction: true,
          }}
        />
      </View>
    ) : (
      <View style={{ maxWidth: 100 }} flex>
        <Button
          {...{
            fullWidth: true,
            disabled: isSubmitDisabled,
            label: "Count",
            onPress: handleSubmit((fields) =>
              submitAdjustBy({
                stockIdentifier: stockSelection?.stockIdentifier,
                adjustBy: fields.counted,
              })
            ),
            isAction: true,
          }}
        />
      </View>
    );

  return (
    <>
      <View style={{ maxWidth: compact ? 200 : "100%" }} flex>
        <TextField
          key="countInput"
          ref={countInputRef}
          inputMode={"numeric" as const}
          keyboardType={"numeric" as const}
          placeholder={"amount"}
          fieldStyle={{
            height: 60,
            width: "100%",
            flexDirection: "column",
            justifyContent: "center",
          }}
          style={{ textAlign: "center" } as const}
          value={adjustBy.toString()}
          onChangeText={handleChangeAdjustBy}
          validationMessage={errors.counted?.message?.toString()}
          onSubmitEditing={handleOnSubmitCount}
          {...ensuredFocusProps}
        />
      </View>
      {primaryButton}
    </>
  );
}
